import apiClient from './apiClient';

/**
 * Récupère la liste des délégués optimisée pour les menus déroulants.
 */
export const getAllDelegatesList = () => {
  const url = '/api/v1/delegates?minimal=true&limit=10000';
  console.log(`[DelegateService Frontend] Appel GET vers ${url}`);
  return apiClient.get(url);
};

export const getDelegatesForPlanning = () => {
  // On appelle le nouvel endpoint en utilisant 'apiClient'
  const url = `/api/v1/delegates/list/for-planning`;
  console.log(`[DelegateService Frontend] Appel GET vers ${url}`);
  return apiClient.get(url);
};

/**
 * Récupère les détails d'un délégué spécifique par son ID.
 * @param {number} id - L'ID du délégué.
 */
export const getDelegateByIdService = (id) => {
  const url = `/api/v1/delegates/${id}`;
  console.log(`[DelegateService Frontend] Appel GET vers ${url}`);
  return apiClient.get(url);
};

/**
 * Récupère la liste des médecins assignés à un délégué spécifique.
 * @param {number} delegateId - L'ID du délégué.
 * @param {number} [doctorTypeId=1] - Le type de personne à récupérer (1 pour médecins).
 */
export const getAssignedDoctorsForDelegate = (delegateId, doctorTypeId = 1) => {
  const url = `/api/v1/persons/delegate/${delegateId}`;
  console.log(`[Service] Appel API docteurs délégué ${delegateId}, type ${doctorTypeId} sur ${url}`);
  return apiClient.get(url, { params: { typeIds: doctorTypeId } });
};

// ==========================================================
// === NOUVELLE FONCTION AJOUTÉE ===
// ==========================================================
/**
 * Désassocie une ou plusieurs personnes d'un délégué.
 * @param {number} delegateId - L'ID du délégué.
 * @param {number[]} personIds - Un tableau des IDs des personnes à désassocier.
 */
export const disassociatePersonsFromDelegate = (delegateId, personIds) => {
  const url = `/api/v1/delegates/${delegateId}/disassociate-persons`;
  console.log(`[DelegateService Frontend] Appel DELETE vers ${url}`);
  
  // Pour une requête DELETE avec Axios, le corps de la requête (body)
  // doit être passé dans un objet de configuration sous la clé "data".
  return apiClient.delete(url, {
    data: { personIds: personIds }
  });
};
// ==========================================================

export const exportAssignedService = (delegateId, params) => {
  const url = `/api/v1/delegates/${delegateId}/export-assigned`;
  return apiClient.get(url, { 
    params,
    responseType: 'blob' 
  });
};